module.exports = __webpack_public_path__ + "static/img/12.29080fe.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/8/eng/12.png
// module id = 4sm2
// module chunks = 0